<template>
  <div class="card border-0">
    <div class="card-header">
      <button type="button" class="close float-right" v-on:click="close()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h3>10% discount on newsletter subscription</h3>
    </div>
    <div class="card-body">
      <mailchimp-subscribe
        url="https://sanitizerwristbands.us17.list-manage.com/subscribe/post-json"
        user-id="67772575e07f881942734ced1"
        list-id="c822de9c66"
        @error="onError"
        @success="onSuccess"
      >
        <template v-slot="{ subscribe, setEmail, error, success, loading }">
          <form class="form" @submit.prevent="subscribe">
            <div class="form-group mb-2 col-md-12">
              <input
                type="email"
                @input="setEmail($event.target.value)"
                class="form-control"
                placeholder="Your email address"
              />
            </div>
            <div class="float-right">
              <button type="submit" v-on:click="track('Subscribed Button Clicked')" class="btn btn-success">Subscribe</button>
            </div>
            <div v-if="loading">Loading…</div>
          </form>
        </template>
      </mailchimp-subscribe>
    </div>
    <div class="coupon" v-if="show">
      <div class="promo">
        Discount Code:
        <strong>{{discount_code}}</strong>
      </div>
    </div>
  </div>
</template>

<script>
import MailchimpSubscribe from 'vue-mailchimp-subscribe'
import { setSubscribeCookie, trackEvent } from '@/mixins/storageMixin'
import eventBus from '@/event'

export default {
  data () {
    return {
      show: false,
      discount_code: 'MEDIUMREADER-10'
    }
  },
  components: {
    MailchimpSubscribe
  },
  methods: {
    onError () {
      console.log('error')
      setSubscribeCookie()
      this.show = true
    },
    onSuccess () {
      this.show = true
      setSubscribeCookie()
    },
    close () {
      eventBus.$emit('close-subscribe-modal')
      setSubscribeCookie()
    },
    track (e) {
      trackEvent(e)
    }
  }
}
</script>
<style lang="css" scoped>
.coupon {
  border: 2px dotted #bbb; /* Dotted border */
  width: 80%;
  margin: 0 auto;
  padding: 10px;
}
.promo {
  padding: 3px;
  color: #000000;
  font: size 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Mailchimp.vue